export interface ServiceRequestMemberHistory {
	id: number;
	selected: number;           // 1 = associated with request, 0 = not associated
	serviceRequestId: number;
	memberId: number;
	firstName: string;
	middleName: string;
	lastName: string;
	dateOfBirth: string;
	gender: string;
	relationship: string;
	address: string;
	county: string;
	email: string;
	phoneNumber: string;
	currentNeed: string;
	memberComments?: string | null;
	createdDate: string;
	createdBy: string;
}

export class ServiceRequestMemberHistory {

	/** Case-level advocate contact only (member_id = 0) — not a household member row */
	public static isContactOnlyAdvocate(h: { relationship?: string; memberId?: number }): boolean {
		return (h?.relationship || '').trim().toLowerCase() === 'advocate' && !h?.memberId;
	}

	constructor() {
		this.id = 0;
		this.selected = 0;
		this.serviceRequestId = 0;
		this.memberId = 0;
		this.firstName = '';
		this.middleName = '';
		this.lastName = '';
		this.dateOfBirth = '';
		this.gender = '';
		this.relationship = '';
		this.address = '';
		this.county = '';
		this.email = '';
		this.phoneNumber = '';
		this.currentNeed = '';
		this.createdDate = '';
		this.createdBy = '';
	}
}
